import { GetMeetingCommand } from "@aws-sdk/client-chime-sdk-meetings";
import { getChimeClient } from "./get-chime-client";
import ToasterWithMessage from "../../components/toaster";

const { error: errorToast } = ToasterWithMessage();

export const getChimeMeeting = async (MeetingId: string) => {
  try {
    const chimeClient = await getChimeClient();

    const getMeetingInput = {
      MeetingId,
    };

    const command = new GetMeetingCommand(getMeetingInput);
    const meetingResponse = await chimeClient.send(command);
    console.log("[Log] Meeting fetched successfully:", meetingResponse);

    // Check if meeting ID is present in the response
    if (!meetingResponse.Meeting || !meetingResponse.Meeting.MeetingId) {
      errorToast("Meeting ID is missing in the response.");
      throw new Error("Meeting ID is missing in the response.");
    }

    return meetingResponse;
  } catch (error: any) {
    if(error?.message?.includes('Meeting') && error?.message?.includes('not found')) {
      errorToast("Meeting not found");
    }else{
      errorToast(error.message);
    }
    console.error("[Log] Failed to fetch meeting:", error.message || error);
  }
};
